import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

const StoresPage = React.lazy(() =>
  import(/* webpackChunkName: 'stores' */ "./pages/stores")
);

function App() {
  const getComponent = (Comp) => {
    const loadingStyle = {
      height: "400px",
      margin: "0 0 0 45%",
      lineHeight: "400px",
    };
    return (
      <React.Suspense fallback={<div style={loadingStyle}></div>}>
        <Comp />
      </React.Suspense>
    );
  };
  return (
    <BrowserRouter>
      <Routes>
        <Route
          key="stores"
          path="stn/build"
          element={getComponent(StoresPage)}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
